import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import './style.scss';
import { useEffect, useState } from 'react';
import PageHeader from '../PageHeader';
import { LOGO_SIZE } from '../../ui/Logo';
import { APP_ROUTES } from '../../app.config.vars/routes';
import Footer from '../Footer';
import Button from '../../ui/Button';
import PasteIcon from '../../assets/icons/paste.svg';
import { useTranslation } from 'react-i18next';
import ClipboardPanel from '../../components/ClipboardPanel';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectClipboardTask, setClipboardTask, setPasteTask, } from '../../store/adminSlices/clipboard';
import { useAppDispatch } from '../../store';
import ClipboardTaskRow from '../../ui/ClipboardTaskRow';
import { selectAdminRally } from '../../store/adminSlices/rallies';
const AdminPageLayout = ({ children, logoLink, logoutButton }) => {
    const { t } = useTranslation();
    const location = useLocation();
    const dispatch = useAppDispatch();
    const [isManageTasksPage, setIsManageTasksPage] = useState(false);
    const clipboardTask = useSelector(selectClipboardTask);
    const rally = useSelector(selectAdminRally);
    useEffect(() => {
        const pathNameChunks = location.pathname.split('/');
        if (pathNameChunks[pathNameChunks.length - 1] === 'tasks') {
            setIsManageTasksPage(true);
        }
    }, []);
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: 'admin-panel', children: [_jsx(PageHeader, { logoSize: LOGO_SIZE.FULL, logoLink: logoLink ? logoLink : APP_ROUTES.adminManageRallies, container: 'admin-container', logoutButton: logoutButton }), _jsx("div", { className: "page-content", children: _jsx("div", { className: "admin-container", children: children }) })] }), _jsx(Footer, { layout: "admin-panel", showCreatorManualLink: Boolean(logoutButton) }), clipboardTask && (_jsx(ClipboardPanel, { label: t('label.copied_task'), additionalControl: isManageTasksPage && rally && !rally.hasStatistics ? (_jsx(Button, { onClick: () => dispatch(setPasteTask(true)), label: t('button.paste_task'), icon: _jsx(PasteIcon, {}), iconSize: 'default' })) : null, onClearClipboard: () => {
                    dispatch(setClipboardTask(null));
                }, children: _jsx(ClipboardTaskRow, { clipboardTask: clipboardTask }) }))] }));
};
export default AdminPageLayout;
